exports.ByName = {
  MasterFileTemplate: { Name: 'MasterFileTemplate', Value: 'Master-File-Template' },
  PlanningTemplate: { Name: 'PlanningTemplate', Value: 'Planning-Template' }
};
